import mutations from './mutations'
import actions from './action'
import getters from './getters'

export default {
  namespaced: true,
  state: {
    workspace: {},
    workspaceReady: false,
    personalList: [],
    enterpriseList: [],
    projectList: [],
    filterData: {
      sortFieldName: 'modifiedTime',
      sortType: 0
    }
  },
  getters,
  actions,
  mutations,
  modules: {}
}
